import { EnvironmentProviders, inject, makeEnvironmentProviders, provideEnvironmentInitializer, Type } from '@angular/core';
import { IotAuthProvider } from '../models/auth-provider.enum';
import { AuthProvider } from './auth-provider';
import { CognitoAuthProvider } from './cognito/cognito-auth.provider';

export const AUTH_PROVIDER_IMPLEMENTATIONS: Record<IotAuthProvider, Type<AuthProvider>> = {
  [IotAuthProvider.COGNITO]: CognitoAuthProvider
};

/** Registers the selected `AuthProvider` implementation and configures it once at startup. */
export function provideAuthProvider(provider: IotAuthProvider = IotAuthProvider.COGNITO): EnvironmentProviders {
  return makeEnvironmentProviders([
    { provide: AuthProvider, useClass: AUTH_PROVIDER_IMPLEMENTATIONS[provider] },
    provideEnvironmentInitializer(() => inject(AuthProvider).configure())
  ]);
}
